export default __webpack_public_path__ + "static/media/digital.dad8270c.jpeg";